export {default as HgDetailBreadcrumbs} from './_components/HgDetailBreadcrumbs'
export {default as HgDetailPageHeader} from './_components/HgDetailPageHeader'
